import { char, integer, pgEnum, pgTable, text, timestamp, unique, uuid, } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema, createUpdateSchema, } from "drizzle-orm/zod";
import { z } from "zod";
const customerIdentifierTypeEnum = ["email", "number"];
export const customerIdentifierType = pgEnum("customer_identifier_type", customerIdentifierTypeEnum);
export const CustomerIdentifierTypeSchema = z.enum(customerIdentifierTypeEnum);
CustomerIdentifierTypeSchema;
export const authorizationTokenTable = pgTable("authorization_token", {
    bcId: text().notNull(),
    token: uuid().primaryKey().defaultRandom().notNull(),
    createdAt: timestamp().defaultNow().notNull(),
});
export const AuthorizationTokenSelectSchema = createSelectSchema(authorizationTokenTable);
export const AuthorizationTokenInsertSchema = createInsertSchema(authorizationTokenTable);
export const AuthorizationTokenUpdateSchema = createUpdateSchema(authorizationTokenTable);
export const customerChangeRequestTable = pgTable("customer_change_request", {
    id: uuid().primaryKey().defaultRandom().notNull(),
    bcId: text().notNull(),
    property: customerIdentifierType().notNull(),
    value: text().notNull(),
    code: char({ length: 6 }).notNull(),
    tries: integer().default(0).notNull(),
    createdAt: timestamp().defaultNow().notNull(),
}, (t) => [unique().on(t.bcId, t.property)]);
export const CustomerChangeRequestSelectSchema = createSelectSchema(customerChangeRequestTable);
export const CustomerChangeRequestInsertSchema = createInsertSchema(customerChangeRequestTable);
export const CustomerChangeRequestUpdateSchema = createUpdateSchema(customerChangeRequestTable);
export const customerLoginCodeTable = pgTable("customer_login_code", {
    identifier: text().primaryKey().notNull(),
    type: customerIdentifierType().notNull(),
    code: char({ length: 6 }).notNull(),
    tries: integer().default(0).notNull(),
    createdAt: timestamp().defaultNow().notNull(),
});
export const CustomerLoginCodeSelectSchema = createSelectSchema(customerLoginCodeTable);
export const CustomerLoginCodeInsertSchema = createInsertSchema(customerLoginCodeTable);
export const CustomerLoginCodeUpdateSchema = createUpdateSchema(customerLoginCodeTable);
